<template>
  <section class="assessmentSection questionsSection">
    <div class="questionsTopBG"></div>

    <div class="pageContent">
      <div
        class="pageTitle"
      >Connectivity is crucial. Let’s learn about your home’s connectivity and communications</div>

      <question id="2" lead-key="phoneService" ref="phoneService">
        <div
          slot="learn-more"
        >Intruders can circumvent security systems that rely on traditional phone line. Phone service offered by cable companies is called VOIP and is not a secure path for transmitting alarms. Our radio network is the fastest most reliable way to transmit alarm signals.</div>
      </question>

      <transition name="fade">
        <div v-if="lead.phoneService">
          <question id="3" lead-key="internetInHome" ref="internetInHome" />
        </div>
      </transition>

      <transition name="fade">
        <div v-if="lead.internetInHome == 'No'">
          <inline-advice>
            <div slot="title">A smart home requires internet connection</div>
            <div slot="text">
              Without internet connection you wont be able to use any
              <router-link to="/assessment/help/what-is-adt-pulse">Pulse home automation features.</router-link>
            </div>
          </inline-advice>
        </div>
      </transition>

      <continue-button :before="mixpanelTracking" to="/assessment/concerns" />
      <div class="startOverSection text-center">
        <a
          href="/assessment/start-over"
          onclick="mixpanel.track('startedOver')"
        >Clear data and start over</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["lead"])
  },
  methods: {
    mixpanelTracking() {
      let data = {
        A_Coms_phoneType: this.lead.phoneService,
        A_Coms_hasInternet: this.lead.internetInHome == "Yes"
      };
      mixpanel.track("completedComsSection", data);
      mixpanel.people.set(data);
    }
  },
  mounted() {
    this.$Progress.set(35);
  }
};
</script>

<style lang="css">
</style>
